<template>
  <v-slide-y-transition mode="out-in">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 xl3 lg3 md5 sm8>
          <v-card class="elevation-12">
            <v-toolbar color="primary">
              <v-toolbar-title>mySuite Forget Password</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  prepend-icon="person"
                  name="username"
                  label="Username"
                  v-model="username"
                  v-validate="'required'"
                  :error-messages="errors.first('username')"
                  type="text"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" @click="PwOnClick()">Proceed</v-btn>              
            </v-card-actions>
          </v-card>
          <div id="msg" style="color: #673ab7; padding-top: 20px; font-size: 18px;"></div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-slide-y-transition>
</template>

<script>
// import auth from "../functions/auth";
import common from "../functions/general";
// import store2 from 'store2';

export default {
  name: "ForgetPW",
  data() {
    return {
      username: ""
    };
  },
  mounted() {
    // store2(false); [note: (OWK) to allow non-registered user access]
  },
  methods: {
    async PwOnClick() {
      common.App.loader.show(this);
      
      let obj = {
        "username": this.username,
        "url_base": window.location.origin
      }

      var res = await common.wBackEndComm.PostData("users/forget_pw/", obj);
			res = res.data;
			if (res.Status == 1) {
        // common.wMsgBox.Success(res.Description);
        window.MainApp.$root.$children[0].msgbox = {
          show: true,
          text: res.Description,
          color: "success",
          timeout: 1000*60*60*2
        };
        
			} else {
				common.wMsgBox.Error(res.Description);
			}
      common.App.loader.hide(this);
    }
  },
  // created (){
  //   auth.hideFooter(true);
  // },
};
</script>

<style>
</style>
